import React, {ReactNode, useContext} from 'react';
import classnames from 'classnames';
import {Chip as PathPill} from '@ellucian/react-design-system/core';

import {PathDesignContext} from './path-design-context';

import Icon from 'shared/components/icon';
import Tooltip from 'src/components/tooltip';

import 'stylesheets/components/shared-pill.scss';
import 'stylesheets/components/shared-tooltip.scss';

export interface PillProps {
  children: ReactNode;
  color?:
    | 'gray'
    | 'dark-gray'
    | 'yellow'
    | 'orange'
    | 'brown'
    | 'blue'
    | 'cyan'
    | 'pink'
    | 'violet'
    | 'purple'
    | 'green'
    | 'white'
    | 'red';

  iconLeft?: string;
  iconRight?: string;
  onClick?: () => void;
  tooltipText?: string | null;
}

const Pill = ({children, color = 'gray', iconLeft, iconRight, onClick, tooltipText}: PillProps) => {
  const path = useContext(PathDesignContext);
  const PillElement = onClick ? 'button' : 'span';
  let pill = (
    <PillElement
      onClick={onClick}
      data-testid="pill-element"
      className={classnames('shared-pill', color)}
    >
      {iconLeft && <Icon className="left" iconType={iconLeft} />}
      <span className="shared-pill-text" data-testid="shared-pill-text">
        {children}
      </span>
      {iconRight && <Icon className="right" iconType={iconRight} />}
    </PillElement>
  );

  if (path.enabled) {
    // Setting onDelete={onClick} bc the only portal on Path (college portal) passes onClick
    // for deleting, if we expand Path we'll need to revisit and probably add a prop
    pill = (
      <PathPill
        label={children}
        onDelete={onClick}
        className="mr-12 mb-8"
        activated={color === 'blue'}
      />
    );
  }

  if (tooltipText) {
    return <Tooltip title={tooltipText}>{pill}</Tooltip>;
  }

  return pill;
};

export default Pill;
